import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import {
  BaseText,
  SkeletonLoader,
  FilterSelect
} from '@warrenbrasil/nebraska-web';

import {
  OrdersFiltersKeys,
  IOrdersFilters
} from '@/modules/wealth/views/IndexPortfolio/components/Orders/types';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  filters: IOrdersFilters;
  isLoading: boolean;
  updatedAt?: string;
}
interface Emit {
  (
    event: 'on-filter-selection',
    filterKey: OrdersFiltersKeys,
    value: string
  ): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OrdersFilters',
  props: {
    filters: null,
    isLoading: { type: Boolean },
    updatedAt: null
  },
  emits: ["on-filter-selection"],
  setup(__props: any, { emit }: { emit: ({
  (
    event: 'on-filter-selection',
    filterKey: OrdersFiltersKeys,
    value: string
  ): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  filters: IOrdersFilters;
  isLoading: boolean;
  updatedAt?: string;
}





const hasFilters = computed(() => {
  const filtersKeys = Object.values(OrdersFiltersKeys);

  return filtersKeys.some(filterKey => {
    return !!props.filters[filterKey].options?.length;
  });
});

const emitOnFilterSelection = (filterKey: OrdersFiltersKeys, value: string) => {
  emit('on-filter-selection', filterKey, value);
};

return { __sfc: true,props, emit, hasFilters, emitOnFilterSelection, BaseText, SkeletonLoader, FilterSelect, OrdersFiltersKeys, NebraskaColors }
}

})